import { useShell } from '../../shell/ShellContext';
import { DispatchProvider } from './DispatchContext';
import BacklogDock from './BacklogDock';
import BoardView from './BoardView';
import CalendarView from './CalendarView';
import TodayView from './TodayView';
import MapViewPanel from './MapViewPanel';
import TechDock from './TechDock';
import DetailDock from './DetailDock';

function DispatchMainView() {
  const { dispatchView } = useShell();

  switch (dispatchView) {
    case 'board':
      return <BoardView />;
    case 'map':
      return <MapViewPanel />;
    case 'today':
      return <TodayView />;
    case 'calendar':
    default:
      return <CalendarView />;
  }
}

export default function DispatchWorkspace() {
  return (
    <DispatchProvider>
      <div className="h-full flex flex-col min-h-0">
        <div className="flex-1 flex min-h-0">
          <BacklogDock />
          <div className="flex-1 min-w-0 min-h-0 flex flex-col">
            <div className="flex-1 min-h-0 overflow-hidden">
              <DispatchMainView />
            </div>
            <TechDock />
          </div>
          <DetailDock />
        </div>
      </div>
    </DispatchProvider>
  );
}
